import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const PhoneFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M16.7 13.32L21 17.64L18.46 20.22C15.1 20.04 11.4 18.28 8.82 15.7C6.26 13.12 4.48 9.42 4.3 6.08L6.88 3.5L11.2 7.82C9.72 9.34 9.74 11.78 11.24 13.28C12.74 14.78 15.18 14.8 16.7 13.32Z" />
    </SvgIcon>
  );
});
